import React, { Component } from 'react';
import queryString from 'query-string';
import { Form, Field } from 'react-final-form';
import { GlobalContext } from '../global-context';
import Styles from "../Styles.js";
import { ProjectDetails } from "../parts/details.js";
import { ProjectTags } from "../parts/tags.js";
import { ProjectResources } from "../parts/resources.js";

export default class ApproveContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            project: null,
            projectID: null
        };
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        const pid = values.project;
        fetch(`/api/project/${pid}`)
            .then(res => res.json())
            .then(proj => {
                this.setState({
                    project: proj,
                    projectID: pid
                });
            });
    }

    onSubmit = async (values) => {
        const endpoint = `/api/project/${this.state.projectID}/approve`;
        let approveObj
        if (values.approval === "approve") {
            approveObj = {
                approved: true
            }
        } else {
            approveObj = {
                approved: false,
                comment: values.reason
            }
        }
        await fetch(endpoint, {
            method: 'PUT',
            body: JSON.stringify(approveObj),
            headers:{
                'Content-Type': 'application/json'
            }
        });
        this.props.navigate(`project/${this.state.projectID}`);
    }

    render() {
        if (this.state.project == null) {
            return null
        }

        const { config, person } = this.context;
        const required = value => (value ? undefined : "Required");
        const needReason = value => (value ? undefined: "Reason required");
        const project = this.state.project;

        return (
            <div style={{padding: "20px"}}>
              <Styles>
                <h1>{project.title}</h1>
                <div>{project.description}</div>
                <div className="project-status">
                  <p>Status: {config.project_states[project.state?project.state:0]}</p>
                  {project.comment && <p>Comment: {project.comment}</p>}
                </div>
                <ProjectDetails project={project} authuser={person} config={config}/>
                <ProjectTags project={project}/>
                <ProjectResources project={project}/>

                <Form
                    onSubmit={this.onSubmit}
                    render={({handleSubmit, submitting, pristine, values, invalid }) => (
                        <form onSubmit={handleSubmit} style={{maxWidth: "500px"}}>
                            <h2>Do you approve this project request? If not, please provide a reason.</h2>
                            <label className="approve-field">
                                <Field
                                    name="approval"
                                    component="input"
                                    type="radio"
                                    value="approve"
                                    validate={required}
                                />
                                Approve
                            </label>
                            <label className="approve-field">
                                <Field
                                    name="approval"
                                    component="input"
                                    type="radio"
                                    value="reject"
                                    validate={required}
                                />
                                Reject
                            </label>
                            <div className="approve-field">
                              { values.approval === "reject" &&
                              <Field
                                  name="reason"
                                  component="input"
                                  validate={needReason}
                              >
                                  {({ input, meta }) => (
                                  <div>
                                      <label>Reason: </label>
                                      <input {...input} type="text" placeholder="required for reject" />
                                          {meta.error && meta.touched && <span> {meta.error}</span>}
                                  </div>
                                  )}
                              </Field>}
                            </div>

                            <button type="submit" disabled={pristine || invalid || submitting}>
                                Submit
                            </button>
                        </form>
                    )}
                />
              </Styles>
            </div>
        );
    }
}
